module.exports = __webpack_public_path__ + "img/glassquality_5.7354fccc.png";